export default __webpack_public_path__ + "static/media/project6.0eef6008.png";